<template>
  <section class="row">
      <div class="p-4 col-12">
      QUANTITY: {{result.length}}
      </div>
      <div v-for="item in result" class="col-4">             
        <router-link :to="'/orders/'+item.id" class="text-primary">{{item.id}} {{item.name}}</router-link> - {{item.campaign_id}}
       <span v-if="loading"  class="loadingres mr-1 ml-1 spinner-border loading-spinner text-primary"></span>
        <span class="badge" :class="item.new_emails == 0 ? 'badge-danger':'badge-secondary'">Emails for tomorrow: {{item.new_emails}}</span>

        <div
            v-if="!loading"
          class="progress mb-2 border bg-secondary"
          style="height: 15px"
        >
          <div
            class="progress-bar bg-primary pl-2 bg-success"
            role="progressbar"
            :style="
              'width:' +
              item.contacts_found_percentage +
              '%;'
            "
          >
            <small
              >{{ new_emails }} ({{
              item.contacts_found_percentage
              }}%) of {{ email_volume }}</small
            >
          </div>
        </div>
    </div>
  </section>
</template>
<script>
import { campaignsService } from "@/_services";

export default {

  props: {
    campaignId: String,
  },

  data () {
    return {
      new_emails: false,
      email_volume: false,
      loading:true,
      result:[]
    }     
  },

  created() {
    campaignsService.getCampaignApolloDetails(this.campaignId).then((result) => {
      this.result = result;
        this.new_emails = result[0].new_emails
        this.email_volume = result[0].email_volume
        this.loading=false
    });
  },

  methods:{
    getPercentageAvailable() {
      let available = this.new_emails
      let total = this.email_volume
      if (available == null) {
        available = 0;
      }
      if (total == null) {
        total = 0;
      }
      if (available == 0 && total == 0) {
        return 0;
      }
      return Math.round((available * 100) / total);
    },

  }

   
  
};
</script>